<template>
  <div class="d-flex flex-wrap w-100">
    <b-col md="4">
      <p class="text-header">
        Type</p>
    </b-col>
    <b-col md="6">
      <p class="text-child text-justify">
        {{ dataReview.content.type_name }} </p>
    </b-col>
    <!-- <b-col
      v-if="dataReview.content.type === 2"
      md="4"
    >
      <p class="text-header">
        Menu Type</p>
    </b-col>
    <b-col
      v-if="dataReview.content.type === 2"
      md="6"
    >
      <p class="text-child">
        {{ dataReview.content.menu_type_name }}</p>
    </b-col> -->
    <b-col
      md="4"
    >
      <p class="text-header">
        Action Link</p>
    </b-col>
    <b-col
      md="6"
    >
      <p class="text-child">
        {{ dataReview.content.action_link }}</p>
    </b-col>
    <b-col
      v-if="dataReview.content.type === 3"
      md="4"
    >
      <p class="text-header">
        Label</p>
    </b-col>
    <b-col
      v-if="dataReview.content.type === 3"
      md="6"
    >
      <p class="text-child">
        {{ dataReview.content.label }}</p>
    </b-col>
    <b-col
      v-if="(dataReview.content.type === 1 || dataReview.content.type === 2)"
      md="4"
    >
      <p class="text-header">
        Banner 300x250</p>
    </b-col>
    <b-col
      v-if="(dataReview.content.type === 1 || dataReview.content.type === 2)"
      md="6"
    >
      <div
        class="d-flex mb-1"
      >
        <b-img
          :src="(dataType) ? dataReview.content.banner : bannerIbnUrl"
          fluid
          alt="Fluid image"
        />
      </div>
    </b-col>
    <!-- <b-col
      v-if="(dataReview.content.menu_type === 1 && dataReview.content.type === 2)"
      md="4"
    >
      <p class="text-header">
        Icon</p>
    </b-col>
    <b-col
      v-if="(dataReview.content.menu_type === 1 && dataReview.content.type === 2)"
      md="6"
    >
      <div
        class="d-flex mb-1"
      >
        <b-img
          :src="(dataType) ? dataReview.content.icon : iconIbnUrl"
          fluid
          alt="Fluid image"
        />
      </div>
    </b-col> -->
  </div>
</template>
<script>
import {
  BCol,
  BImg,
} from 'bootstrap-vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    BCol,
    BImg,
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    dataReview: Object,
    dataType: {
      default: true,
      type: Boolean,
    },
  },
  computed: {
    ...mapGetters('campaign', {
      bannerIbnUrl: 'getBannerIbn',
      iconIbnUrl: 'getIconIbn',
    }),
  },
  mounted() {
    // console.log(this.dataReview, 'data review')
    // console.log(this.bannerIbnUrl, 'data review')
  },
  methods: {
    setString(data) {
      let str = (data) || []
      return str.toString()
    },
  },
}
</script>

<style scoped>
.text-header {
  font-size: 14px;
  color: #5E5873;
  font-weight: bold;
}
.text-child {
  font-size: 12px;
  color: #4B6AAE;
}
</style>
